import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=64f1219a"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64f1219a')) {
      api.createRecord('64f1219a', component.options)
    } else {
      api.reload('64f1219a', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=64f1219a", function () {
      api.rerender('64f1219a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/Home.vue"
export default component.exports